import React, { useState, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import Button from '../../elements/Button';
import DiaryTable from '../DiaryTable/DiaryTable';
import { DiaryTableRef } from '../DiaryTable/DiaryTable';
import { useGetDiariesByUserIdQuery } from '../../api/phoenix';

interface DiaryProps {
  id: string;
}

const Diary: React.FC<DiaryProps> = ({ id }) => {
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const classes = useStyles();
  const diaryTableRef = useRef<DiaryTableRef>(null);
  const [diaryEntries, setDiaryEntries] = useState<any[]>([]);

  const {
    data,
    isLoading: isDiaryLoading,
    isFetching: isLoadingMore,
  } = useGetDiariesByUserIdQuery(
    {
      id: id || '',
      page: page,
      pageSize: pageSize,
    },
    { skip: !id }
  );

  useEffect(() => {
    if (data?.data?.page) {
      setPage(data.data.page);
    }

    if (data?.data?.diaryEntries) {
      setDiaryEntries(prevEntries => [...prevEntries, ...data.data.diaryEntries]);
    }
  }, [data]);

  const handleScrollToTop = () => {
    if (diaryTableRef.current) {
      diaryTableRef.current.scrollToTop();
    }
  };

  const handleLoadMore = () => {
    setPage(prevPage => prevPage + 1);
  };

  return (
    <div className={classes.container}>
      <div className={classes.button}>
        <Button onClick={handleScrollToTop} variant={'secondary'}>
          Zum letzten Eintrag
        </Button>
      </div>
      <DiaryTable
        ref={diaryTableRef}
        entries={diaryEntries}
        isLoading={isDiaryLoading}
        onLoadMore={handleLoadMore}
        isLoadingMore={isLoadingMore}
        hasMore={data?.data?.hasNextPage}
      />
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    paddingBottom: 24,
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default Diary;
